import moment from "moment";
import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getTasks(policyHolder) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      gXdpApi: {
        transactionType: {
          eventName: "GETTASK",
          sourceNameSpace: "LIFESYS",
          targetNameSpace: "GIDP",
          operation: "GET",
        },
        gIdpPayLoad: {
          policyHolder,
          addOnProperties: {
            lifesys: {
              policyHolder: {
                company: config.COMPANY,
                clientName: config.CLIENTNAME,
                system: "LSN",
                lifeSysDataset: "P",
                searchType: "IN",
                requestDomesticViolenceFlag: "",
                recordsRequested: 20,
                dvInclude: "",
                includecomplianceFlag: "",
                contractExpiryDuration: "",
                suppressRider: "",
                clientGroupSeach: "",
                ShowTotalRequestTime: "",
              },
            },
          },
        },
        parentCorrelationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        addOnProperties: {},
      },
    }),
  };
  const response = await fetch(
    config.ODS_API_BASE_URL + "/evl/GetTask",
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    if (data?.gXdpApi?.success) {
      return data.gXdpApi?.gIdpPayLoad?.policyHolder?.taskDetails;
    }
    return;
  }
}
